import isBrowser from "@secureo/common/utils/isBrowser"

const getUserLocale = (locale?: string) => locale || (isBrowser() ? navigator.language : "de-DE")

export default getUserLocale
